/**
 * Utility to determine field options for Collection List Filters configuration
 */

import type {
  BindingSource,
  ConsolidatedBindingContext,
} from '@packages/systems/dynamo/gateway';

import {hasAllowedType} from './ParamPanelUtils';

const hasFilterCompatibleBindingPath = (source: BindingSource) =>
  source.path.length === 1;

export function getFilterBindingSources(
  bindingContext: ConsolidatedBindingContext
): BindingSource[] {
  const bindingSources = bindingContext.getExpandedBindingSources();
  return bindingSources.filter(
    (source) => hasAllowedType(source) && hasFilterCompatibleBindingPath(source)
  );
}
